import { Inject, Injectable, Optional } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

import { ToasterError } from './toaster.error';
import { NEWRELIC, Newrelic } from '@purespectrum1/ui/tracking';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(
    private _toastrService: ToastrService,
    @Optional() @Inject(NEWRELIC) private _newrelic?: Newrelic
  ) {}

  success(msg: string, title?: string, config?: Partial<IndividualConfig>) {
    this._toastrService.success(msg, title, { closeButton: true, ...config });
  }

  info(msg: string, title?: string, config?: Partial<IndividualConfig>) {
    return this._toastrService.info(msg, title, {
      closeButton: true,
      ...config,
    });
  }

  warning(msg: string, title?: string, config?: Partial<IndividualConfig>) {
    this._toastrService.warning(msg, title, {
      disableTimeOut: true,
      closeButton: true,
      ...config,
    });
  }

  error(msg: string, title?: string, config?: Partial<IndividualConfig>) {
    this._newrelic?.noticeError(new ToasterError(msg), { title });
    this._toastrService.error(msg, title, {
      disableTimeOut: true,
      closeButton: true,
      ...config,
    });
  }

  clear(toastId: number) {
    this._toastrService.clear(toastId);
  }
}
